import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navigation from "./components/Navigation";
import Login from "./pages/Login";
import Register from "./pages/Register";
import LandingPage from "./pages/LandingPage";
import Home from "./pages/Home";
import Customers from "./pages/Customers";
import Employee from "./pages/Employee";
import Services from "./pages/Services";
import Report from "./pages/Report";
import Bests from "./pages/Bests";
import Appointments from "./pages/Appointments";
import Customization from "./pages/Customization";
import LoyaltyConfig from "./pages/LoyaltyConfig";
import BookingPage from "./pages/BookingPage";
import BusinessProfileSetup from "./pages/BusinessProfileSetup";
import Billing from "./pages/Billing";
import Settings from "./pages/Settings";
import SmsSettings from "./pages/SmsSettings";
import TeamManagement from "./pages/TeamManagement";
import AdminPanel from "./pages/AdminPanel";
import AdminLeads from "./pages/AdminLeads";
import AdminFunnel from "./pages/AdminFunnel";
import AdminCampaigns from "./pages/AdminCampaigns";
import CommissionReport from "./pages/CommissionReport";

import Modal from 'react-modal';

Modal.setAppElement('#root');

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/book/:businessSlug" element={<BookingPage />} />
            
            {/* Protected routes */}
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <div className="flex flex-col min-h-screen">
                    <Navigation />
                    <main className="flex-grow">
                      <div className="max-w-7xl mx-auto px-4 py-6">
                        <Routes>
                          <Route path="/home" element={<Home />} />
                          <Route path="/customers" element={<Customers />} />
                          <Route path="/employee" element={<Employee />} />
                          <Route path="/services" element={<Services />} />
                          <Route path="/report" element={<Report />} />
                          <Route path="/bests" element={<Bests />} />
                          <Route path="/appointments" element={<Appointments />} />
                          <Route path="/customization" element={<Customization />} />
                          <Route path="/loyalty-config" element={<LoyaltyConfig />} />
                          <Route path="/business-profile" element={<BusinessProfileSetup />} />
                          <Route path="/billing" element={<Billing />} />
                          <Route path="/settings" element={<Settings />} />
                          <Route path="/sms-settings" element={<SmsSettings />} />
                          <Route path="/commissions" element={<CommissionReport />} />
                          <Route path="/packages" element={<Navigate to="/services" replace />} />
                          <Route path="/team" element={<TeamManagement />} />
                          <Route path="/admin" element={<AdminPanel />} />
                          <Route path="/admin/leads" element={<AdminLeads />} />
                          <Route path="/admin/funnel" element={<AdminFunnel />} />
                          <Route path="/admin/campaigns" element={<AdminCampaigns />} />
                        </Routes>
                      </div>
                    </main>
                  </div>
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;